import React from "react";

const DashboardPage = () => {
  return (
    <div className="Content DashBoardPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">
          DashBoard
        </div>
      </div>
      <div className="ContentMain">
      </div>
    </div>
  );
};

export default DashboardPage;
